import { Flex, Select, Input, ConfigProvider } from 'antd';
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Icon from '@ant-design/icons';
import { ReactComponent as Search } from '../../../assets/icons/search.svg';
import { ReactComponent as SearchBlack } from '../../../assets/icons/search-black.svg';
import { ReactComponent as Down } from '../../../assets/icons/down.svg';
import { ReactComponent as DownBlack } from '../../../assets/icons/down-black.svg';
import { useTheme } from '../../../context/ThemeContext';
import { DARK } from '../../../utilities/constants';
import { sanitizeInput } from '../../../utilities/commonFunctions';
import EmptyCard from '../../../components/EmptyCard/EmptyCard';

const SearchBarWithFilter = ({
  selectOptions = [],
  selectedOption = '',
  setSelectedOption = () => {},
  searchValue = '',
  setSearchValue = () => {},
  handleSelectFilterChange = () => {},
  loading = false,
  flexDirection = 'horizontal',
  borderColor = '#FFFFFF',
  skipSearchBarInitialEffect = false,
}) => {
  const [isInputFocused, setIsInputFocused] = useState(false);
  const { theme } = useTheme();

  const handleSelectChange = value => {
    setSelectedOption(value);
  };

  const handleSearchChange = e => {
    setSearchValue(sanitizeInput(e.target.value));
  };

  useEffect(() => {
    if (!skipSearchBarInitialEffect) {
      handleSelectFilterChange();
    }
  }, [searchValue, selectedOption]);

  return (
    <ConfigProvider
      theme={{
        components: {
          Input: {
            activeBg: '#003253',
            colorBgContainer: theme === DARK ? '#383B3E' : '#D0D4D8',
          },
          Select: {
            selectorBg: theme === DARK ? '#2E3033' : '#E0E2E5',
          },
        },
      }}
    >
      <Flex
        style={{
          flexDirection: flexDirection === 'vertical' ? 'column' : 'row',
        }}
      >
        <Select
          onChange={handleSelectChange}
          defaultValue="Sticker ID"
          size="large"
          suffixIcon={
            <Icon
              component={theme === DARK ? Down : DownBlack}
              style={{
                pointerEvents: 'none',
              }}
            />
          }
          type="borderless"
          className="custom-select-dropdown"
          style={{
            minWidth: 191,
            borderBottom: isInputFocused
              ? `3px solid var(--primary-text-color, ${borderColor})`
              : `1px solid var(--primary-text-color, ${borderColor})`,
          }}
          disabled={loading}
          notFoundContent={<EmptyCard />}
        >
          {selectOptions.map(item => (
            <Select.Option value={item} key={`trip_status-${item}`}>
              {item}
            </Select.Option>
          ))}
        </Select>
        {flexDirection === 'horizontal' && theme === DARK && (
          <div
            style={{
              width: '1px',
              backgroundColor: '#FFFFFF',
            }}
          />
        )}
        <Input
          size="large"
          placeholder="What are you searching for?"
          value={searchValue}
          onChange={handleSearchChange}
          onFocus={() => setIsInputFocused(true)}
          onBlur={() => setIsInputFocused(false)}
          suffix={
            <div
              style={{
                backgroundColor: theme === DARK ? '#2E3033' : '#E0E2E5',
              }}
            >
              <Icon
                component={theme === DARK ? Search : SearchBlack}
                width={20}
                height={20}
                className="search-icon"
              />
            </div>
          }
          className={`input-search full-width input-search-with-select ${
            theme === DARK && flexDirection === 'horizontal'
              ? 'input-search-with-select-border'
              : ''
          }`}
          style={{
            maxWidth: 400,
            minWidth: 350,
            borderBottomWidth: isInputFocused ? '3px' : '1px',
          }}
          disabled={loading}
        />
      </Flex>
    </ConfigProvider>
  );
};

SearchBarWithFilter.propTypes = {
  selectOptions: PropTypes.array,
  selectedOption: PropTypes.string,
  setSelectedOption: PropTypes.func,
  searchValue: PropTypes.string,
  setSearchValue: PropTypes.func,
  handleSelectFilterChange: PropTypes.func,
  loading: PropTypes.bool,
  flexDirection: PropTypes.string,
  borderColor: PropTypes.string,
  skipSearchBarInitialEffect: PropTypes.bool,
};

export default SearchBarWithFilter;
